import React, { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard, faList } from "@fortawesome/free-solid-svg-icons";
import "../../assets/styles/barhide.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom";
import NfsmSidebar from "../Common/NfsmSidebar";
import axios from "axios";
import MaterialReactTable from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { set } from "date-fns/esm";
import { NavLink } from "react-router-dom";

function NMEOScheme3F() {
  const [seasonValue, setSeasonValue] = useState("");
  const [cropGroupValue, setCropGroupValue] = useState("");
  const [cropNameValue, setCropNameValue] = useState("");
  const [cropVarietyValue, setCropVarietyValue] = useState("");

  const [cropGroupData, setCropGroupData] = useState([]);
  const [cropNameData, setCropNameData] = useState([]);
  const [cropVarietyData, setCropVarietyData] = useState([]);

  const [nfsmData, setNfsmData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const columns = useMemo(() => [
    {
      header: "S.No",
      Cell: (cell) => Number(cell.row.id) + 1,
      size: 1
    },
    {
      accessorFn: () => "3F",
      header: "Company name",
    },
    {
      accessorKey: "stateName",
      header: "State",
    }, 
    {
      accessorKey: "stateWiseTotalArea",
      header: "State wise total area",
    },
    {
      accessorKey: "oilPalmArea",
      header: "Target area"
    } ,
    
    {
      accessorKey: "totalFarmers",
      header: "Number of Farmers",
    }, 
    {
      accessorKey: "farmersTotalArea",
      header: "Farmers total area",
    },
    {
      accessorKey: "totalPlants",
      header: "Number of Plantation",
    }
  
  ],[]);

  console.log("columns", columns)
  const visibleColumns = columns.filter(column => column.isVisible !== false);
  console.log("visibleColumns", visibleColumns)

  useEffect(() => {
  const cropGroup = async () => {
    setIsFetching(true);
    try {
      const result = await axios.post(
        `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/NMEOMISReport`,
        {
          case: "1",
          stateCode: "0",
          districtCode: "0",
          subDistrictCode: "0",
          villageCode: "0",
        }
      );

      const data = result.data.dataContent;
      setCropGroupData(data);
      setNfsmData(data); // Set data for table
      } catch (error) {
        console.error("Error fetching crop group data:", error);
      } finally {
        setIsFetching(false);
      }
    };

    cropGroup();
  }, []);


  // Below Code is use to download table data as CSV
  const handleExportData = () => {
    const csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: Object.keys(nfsmData[0]),
    };

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(nfsmData);
  };

  return (
    <>
       <aside id="myDIV" className="sidebar mapsidebar">
         <ul class="sidebar-nav" id="sidebar-nav">
           <li class="nav-item">
           <NavLink className="nav-link collapsed" to="/nmeoscheme"><i><FontAwesomeIcon icon={faList}/> </i><span> KE Cultivation NMEO Reports</span></NavLink>
              </li>
           <li class="nav-item">
           <NavLink className="nav-link collapsed" to="/nmeoscheme3f"><i><FontAwesomeIcon icon={faList}/> </i><span>3F NMEO Reports</span></NavLink></li>
           <li class="nav-item" style={{ display: 'none' }}>
           <NavLink className="nav-link collapsed" to="/NFSMFarmersOutcomesUploadedReport"><i><FontAwesomeIcon icon={faList}/> </i><span> Farmers Outcomes Uploaded</span></NavLink></li>
           <li class="nav-item d-none">
              <NavLink className="nav-link collapsed" to="/schemereports"><i><FontAwesomeIcon icon={faDashboard}/> </i><span> All Schemes</span></NavLink></li>
        </ul>
       </aside>
      <div className="page-wrapper chiller-theme toggled">
        <main id="main" className="main nmeo-report">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h1>NMEO Reports</h1>
             
            </nav>
            
          </div>
          
          <div className="row">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={nfsmData} // Pass the processed data
                  enableColumnOrdering
                  enablePagination={true}
                  state={{ isLoading: isFetching }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        color="primary"
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export in CSV
                      </Button>
                    </Box>
                  )}
                />

              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default NMEOScheme3F;
